import type { RouteObject } from 'react-router-dom';
import Home from '@/pages/home/page';
import Category from '@/pages/category/page';
import ComicDetail from '@/pages/comic/page';
import About from '@/pages/about/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/category/:type',
    element: <Category />,
  },
  {
    path: '/comic/:id',
    element: <ComicDetail />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;